var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"top-menu"},[_c('div',{staticClass:"top-menu--left"},[_vm._t("left")],2),_c('div',{staticClass:"top-menu--right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }